import * as navStyles from '../../../styles/layout/navigation-nojs.module.scss';

import React, {Fragment} from 'react';

import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import PolyLink from '../../shared/PolyLink';
import _ from 'lodash';
import clsx from 'clsx';
import {faCaretUp} from '@fortawesome/free-solid-svg-icons';
import {faCircle} from '@fortawesome/free-regular-svg-icons';
import {getSiteURL} from '../../../utils/parsing';
import {handleMenuMouseLeave} from '../../../services/menuEventUtils';

const SiteNavigationHtml = (props) => {
  const siteURL = getSiteURL(_.get(props, 'siteURL'));
  const menu = _.get(props, 'menu[0]');

  const getURL = (target, n1_slug, n2_slug) => {
    let URL = '';

    if (!target || target.type === 'menu') {
      return URL;
    }
    if (target.type === 'strapi') {
      URL += siteURL;
      if (n1_slug) {
        URL += n1_slug + '/';
      }
      if (n2_slug) {
        URL += n2_slug + '/';
      }
      return (URL + target.slug);
    }
    if (target.type === 'strapi_events' || target.type === 'strapi_news') {
      return siteURL + target.slug;
    }
    if (target.type === 'external_link') {
      return target.uid;
    }
  };

  const formatColumns = (n2) => {
    const tab = [];
    let subtab = [];
    for (let idx = 0; idx < n2.length; idx++) {
      subtab.push(n2[idx]);
      if (n2[idx].newColumn) {
        tab.push(subtab);
        subtab = [];
      }
    }
    tab.push(subtab);
    return tab;
  };

  const [openMenu, setOpenMenu] = React.useState(false);
  const [idFocus, setIdFocus] = React.useState(null);

  let mouseTarget = null;
  const ref = React.useRef({});

  React.useEffect(() => {
    for (const k of Object.keys(ref.current)) {
      const rf = ref.current[k];
      if (rf && rf.children) {
        for (const child of rf.children) {
          child.classList.remove(navStyles.nojs);
        }
      }
    }
  }, []);

  let addOnClickEvent = () => {
    return null;
  };

  const resetStyles = () => {
    mouseTarget.classList.remove(navStyles.js);
    mouseTarget.classList.remove(navStyles.selectN1);
  };

  if (typeof window !== 'undefined') {

    addOnClickEvent = (id) => {
      mouseTarget = document.getElementById(id);
      handleMenuMouseLeave('navigation', resetStyles);
      for (const k of Object.keys(ref.current)) {
        const rf = ref.current[k];
        for (const child of rf.children) {
          if (child.id === id) {
            child.classList.toggle(navStyles.js);
            child.classList.toggle(navStyles.selectN1);
          } else {
            child.classList.remove(navStyles.js);
            child.classList.remove(navStyles.selectN1);
          }
        }
      }
    };
  }

  let addClickonKeyUp = () => {
    return null;
  };

  if (typeof window !== 'undefined') {
    addClickonKeyUp = (event, id) => {
      event.preventDefault();
      const target = document.getElementById(id);
      if (event.key === 'Tab') {
        if (target.children.length === 1) {
          target.addEventListener('focusout', () => target.click());
        }
        if (!openMenu) {
          target.click();
          setIdFocus(id);
          setOpenMenu(true);
        }
        if (id !== idFocus && idFocus !== null) {
          target.click();
          setIdFocus(id);
          setOpenMenu(true);
        }
      }
    };
  }

  const n1_html = (n1, n1_index) => {
    let columns = n1?.target_object?.menu || [];
    columns = formatColumns(_.filter(columns, (item) => item.visible));
    const url = getURL(n1?.target_object);
    const id = 'li1' + n1_index;
    return (
      <button
        className={clsx(navStyles.level1Item, navStyles.nojs)}
        data-cy="menu-desktop-level-one-item"
        id={id}
        onClick={() => addOnClickEvent(id)}
        onKeyUp={(event) => addClickonKeyUp(event, id)}
        tabIndex={0}
      >
        <div className={navStyles.navigationLevel1Item}>
          <div className={navStyles.navigationItem}>
            <div className={navStyles.invisible}>
              {!url && (
                <p
                  className={navStyles.navigationLevel1InvisibleTitle}
                >
                  {n1.label}
                </p>
              )}
              {url && (
                <PolyLink
                  ariaLabel={n1.label}
                  className={clsx(navStyles.navigationLevel1LinkTitle, {[navStyles.targetBlank]: n1.new_window})}
                  name={n1.label}
                  notFocus
                  target={n1.new_window ? '_blank' : '_self'}
                  url={url}
                >
                  {n1.label}
                </PolyLink>
              )}
            </div>
            <div
              className={navStyles.visible}
            >
              <div>
                {!url && (
                  <>
                    <p
                      className={navStyles.navigationLevel1Title}
                    >
                      {n1.label}
                    </p>
                    {!url && (
                      <FontAwesomeIcon
                        className={navStyles.navigationFaCaretUp}
                        color={'#ffffff'}
                        icon={faCaretUp}
                        size="3x"
                      >
                      </FontAwesomeIcon>
                    )}
                  </>
                )}
                {url && (
                  <PolyLink
                    ariaLabel={n1.label}
                    className={clsx(navStyles.navigationLevel1LinkTitle, {[navStyles.targetBlank]: n1.new_window})}
                    name={n1.label}
                    target={n1.new_window ? '_blank' : '_self'}
                    url={url}
                  >
                    {n1.label}
                  </PolyLink>
                )}
              </div>
            </div>
          </div>
        </div>
        {n1.target_object?.type === 'menu' && (
          <div className={navStyles.navigationLevel2Container}>
            {columns.map((column, column_index) => {
              return (
                <div className={navStyles.navigationLevel2ColumnContainer}
                  key={'div1' + column_index}
                >
                  <ul
                    className={navStyles.navigationLevel2ListContainer}
                  >
                    {column.map((n2, n2_index) => {
                      if (n2.visible && n2.label) {
                        return n2_html(n2, n2_index, n1);
                      }
                      return <Fragment key={'frag2' + n2_index}/>;
                    })}
                  </ul>
                </div>);
            })}
          </div>
        )}
      </button>
    );
  };

  const n2_html = (n2, n2_index, n1) => {
    const url = getURL(n2.target_object, n1.slug);
    return (
      <li className={navStyles.level2Item}
        key={'li2' + n2_index}
      >
        <div className={navStyles.level2Div1}>
          <div className={navStyles.level2Div2}>
            <PolyLink
              ariaLabel={n2.label}
              className={navStyles.level2Div3}
              dataCy="menu-desktop-level-two-item"
              name={n2.label}
              target={n2.new_window ? '_blank' : '_self'}
              url={url}
            >
              <p className={navStyles.level2P3}>
                {n2.label}
              </p>
            </PolyLink>
          </div>
          <ul className={navStyles.navigationLevel3ListContainer}>
            {n2?.target_object?.menu?.map((n3, n3_index, arr) => {
              if (n3.visible) {
                return n3_html(n3, n3_index, arr.length, n1, n2);
              }
              return <Fragment key={'frag3' + n3_index}/>;
            })}
          </ul>
        </div>
      </li>);
  };

  const n3_html = (n3, n3_index, n3_length, n1, n2) => {
    const url = getURL(n3.target_object, n1.slug, n2.slug);
    return (
      <li className={navStyles.level3Item}
        key={'li3' + n3_index}
      >
        <PolyLink
          ariaLabel={n3.label}
          className={clsx(navStyles.level3Div1, {
            [navStyles.level3Div1Border]: n3_index < n3_length - 1,
          })}
          dataCy="menu-desktop-level-three-item"
          name={n3.label}
          target={n3.new_window ? '_blank' : '_self'}
          url={url}

        >
          <FontAwesomeIcon
            className={navStyles.level3Icon}
            color="var(--red-color)"
            icon={faCircle}
            size="sm"
          >
          </FontAwesomeIcon>
          <p
            className={navStyles.navigationLevel3Title}
            name={n3.label}
          >
            {n3.label}
          </p>
        </PolyLink>
      </li>
    );
  };

  return (
    <div className={navStyles.navigationContainer}
      id="navigation"
    >
      <ul className={navStyles.navigationLevel1Container}>
        {menu?.items?.map((n1, n1_index) => {
          if (n1.visible) {
            return (
              <li key={'li1' + n1_index}
                ref={(element) => ref.current[n1_index] = element}
              >
                {n1_html(n1, n1_index)}
              </li>
            );
          }
          return <Fragment key={'frag1' + n1_index}/>;
        })}
      </ul>
    </div>
  );
};

export default SiteNavigationHtml;
